import { FC, MouseEvent, ReactNode } from 'react';
import { FormCheck } from 'react-bootstrap';
import classlist from 'utils/classlist';
import './style.scss';

export interface SwitchProps {
    id: string;
    reverse?: boolean;
    underline?: boolean;
    checked?: boolean;
    label?: ReactNode;
    children?: ReactNode;
    inline?: boolean;
    disabled?: boolean;
    type?: 'success' | 'info' | 'primary' | 'danger' | 'warning';
    className?: string;
    onChange?(value: boolean): void;
    onClick?(event: MouseEvent): void;
}

interface SwitchComponent extends FC<SwitchProps> {
    formutilType?: string;
}

const Switch: SwitchComponent = ({
    id,
    type = 'primary',
    checked,
    inline,
    disabled,
    reverse,
    underline,
    onChange,
    onClick,
    label,
    children,
    className
}) => {
    const handleChange = () => {
        onChange?.(!checked);
    };

    return (
        <FormCheck
            type="switch"
            id={id}
            label={label || children}
            disabled={disabled}
            checked={checked}
            onChange={handleChange}
            className={classlist(
                'form-check-switch',
                `form-check-switch-${type}`,
                {
                    'form-check-switch-inline': inline,
                    'form-check-switch-underline': underline,
                    'form-check-switch-reverse': reverse
                },
                className
            )}
            onClick={onClick}
        />
    );
};

Switch.formutilType = 'checked';

export default Switch;
